import * as React from 'react';

import RadioButton from 'src/components/common/RadioButton';

import './PaymentMethodChange.scss';
import env from 'src/shared/env';

interface IPaymentMethodChangeProps {
  account: string;
  savedPaymentMethod: string;
  handleClose: () => void;
  handlePaymentMethodSave: (e: any) => void;
  savedCreditCards: number;
  t?: any;
}

interface IPaymentMethodChangeState {
  paymentMethod: string;
}

class PaymentMethodChange extends React.Component<
  IPaymentMethodChangeProps,
  IPaymentMethodChangeState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      paymentMethod: this.props.savedPaymentMethod
    };
  }

  private handlePaymentMethodChange = (e: any) => {
    if( e.target.value==="004"){
      if(this.props.savedCreditCards>0){
        this.setState({ paymentMethod: e.target.value });
      }else{
        this.setState({ paymentMethod: "002" });
      }
    }else{
      this.setState({ paymentMethod: e.target.value });
    }
  };

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-payment-method-change">
        <div className="rp-payment-method-change--top">
          <div className="rp-payment-method-change--directions-text">
            {t('payment.chooseMethod')}:
          </div>
          <span
            onClick={e => this.props.handleClose()}
            className="rpds-close rp-payment-method-change--close-modal-icon"
          />
        </div>
        <div className="rp-payment-method-change--options">
          <div className="rp-payment-method-change--option">
            <label className="rp-payment-method-change--option-label">
              {t('accountMonthlyStatements.account')} {this.props.account}
            </label>
            <RadioButton
              name={t('checkoutPage.payByAccount')}
              value={'001'}
              checked={this.state.paymentMethod === '001' ? true : false}
              onChange={this.handlePaymentMethodChange}
            />
          </div>
          {
            <div className="rp-payment-method-change--option visa">
              <div>
                <label className="rp-payment-method-change--option-label">
                  {t('accountCreditCards.tableCreditCard')}
                  {/* <span
                  className="rp-payment-method-change--link"
                  onClick={this.handleChangeCreditCard}
                >
                  Change
                </span> */}
                </label>
                <RadioButton
                  name={t('checkoutPage.payByCreditCardModal')}
                  value={'004'}
                  checked={this.state.paymentMethod === '004' || this.state.paymentMethod === '002' ? true : false}
                  onChange={this.handlePaymentMethodChange}
                />
                <label className="rp-payment-method-change--option-instruction">
                  ({t('checkoutPage.clickToPlaceOrder')})
                </label>
              </div>
            </div>
          }
          {/* <div className="rp-payment-method-change--option">
            <label className="rp-payment-method-change--option-label">
              Secure external Payment
            </label>
            <RadioButton
              name={"Pay by e-check"}
              value={"003"}
              checked={this.state.paymentMethod === "003" ? true : false}
              onChange={this.handlePaymentMethodChange}
            />
    </div> */}
        </div>
        <div className="rp-payment-method-change--button">
          <button
            className="primary-button"
            onClick={e =>
              this.props.handlePaymentMethodSave(this.state.paymentMethod)
            }
          >
            {t('checkoutPage.selectPayment')}
          </button>
        </div>
      </div>
    );
  }
}

export default PaymentMethodChange;
